import './estateflorentine/style';
import FormStructure from './estateflorentine/form_structure';

export default FormStructure;